export enum ERPSortType {
    Id,
    Name,
    IsDeleted
}
